<template>
	<div style="">
		<div style="width: 100%;background-color: #fff;">
			<div style="padding: 10px;font-weight: bold;font-size: 18px;">字体设置</div>
			<div style="height:  1px;background-color: #c7c7c7;margin: auto;margin: 6px;"></div>
			<div style="padding: 5px 10px;display: flex;align-items: center;">
				<div>字体颜色 </div>
				<el-color-picker style="margin-left: 10px;" v-model="dataItem.setColor.color"></el-color-picker>
			</div>
			<div style="padding:  5px 10px;display: flex;align-items: center;">
				<div>字体大小 </div>
				<el-input @input="ipt(dataItem.setFontSize,'fontSize')" @change="changeIpt(dataItem.setFontSize)"
					style="width: 240px;margin-left: 10px;" placeholder="请输入内容" v-model="dataItem.setFontSize.fontSize"
					clearable>
					<template slot="append">px</template>
				</el-input>
			</div>
			<div style="padding:  5px 10px;display: flex;align-items: center;">
				<div>默认选择 </div>
				<el-select :style="getFontStyle({
					name:dataItem.setfontFamily.fontFamily,
					css:dataItem.setfontFamily.css
				})" @change="selectFont" style="width: 240px;margin-left: 10px;" v-model="dataItem.setfontFamily.fontFamily"
					placeholder="请选择">
					<div :style="getFontStyle(fontItem)"
						style="display: flex;align-items: center;justify-content: space-between;"
						v-for="(fontItem,index) in dataItem.setfontFamily.fontList" :key="index">
						<el-option style="width: 280px;" :label="fontItem.code" :value="fontItem.name">
						</el-option>
					</div>
				</el-select>
			</div>
		</div>
		<div style="width: 100%;background-color: #fff;margin-top: 20px;padding: 10px;overflow: scroll;">
			<div v-loading="loading" v-if="value"
				style="width: 100%;height: calc(100vh - 165px);padding:0px 0px;display: flex;justify-content: space-between;">
				
				<div style="width: 23%;" :key="spIndex" v-for="(spItem,spIndex) in splitArrayIntoFourParts(dataFontList)">
					<div v-for="(fontItem,index) in spItem" :key="index"
						style="width: 100%;display: flex;justify-content: space-between;margin-top: 20px;">
						<div :style="getFontStyle(fontItem)">
							{{fontItem.code}}
						</div>
						<el-switch @change="changeSelect($event,fontItem)" v-model="fontItem.select" active-color="#13ce66"
							inactive-color="#ff4949">
						</el-switch>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getDesignGetFonts
	} from '../../api/all.js'

	export default {
		components: {
			getDesignGetFonts
		},
		props: {
			systemConfig: {
				type: Object,
				default: () => {
					return {}
				}
			},
			dataItem: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				loading: false,
				value: true,
				allFontList: [],
				addFontFamily: "",
				dataFontList: [],
				fontDialogVisible: false,
				dialogVisible: false,
				fontList: []
			}
		},
		async mounted() {
			try {
				this.loading = true
				let wsid = this.$cookies.get("wsid")
				let data = await getDesignGetFonts({
					wsid
				})
				let list = data.data.data
				list.forEach(item => {
					item.select = false
				})
				this.dataFontList = list
				if (this.dataItem.setfontFamily.fontList.length == 0) {
					if (this.allFontList.length > 0) {
						this.dataItem.setfontFamily.fontList.push(this.dataFontList[0])
						this.dataItem.setfontFamily.fontFamily = this.dataFontList[0].name
						this.dataItem.setfontFamily.name = this.dataFontList[0].code
						this.dataItem.setfontFamily.css = this.dataFontList[0].css
					}
				}
				this.fifter()
				// this.getFontStyle()
				console.log('this.dataFontList', this.dataFontList)
				console.log('getDesignGetFonts', data.data.data)
				this.loading = false
			} catch (e) {
				this.loading = false
			}
		},
		methods: {

			splitArrayIntoFourParts(arr) {
				const result = [];
				const partSize = Math.ceil(arr.length / 4); // 每部分的最大长度

				for (let i = 0; i < 4; i++) {
					result.push(arr.slice(i * partSize, (i + 1) * partSize));
				}

				return result;
			},


			changeSelect(e, fontItem) {
				console.log('changeSelect', e)
				// fontItem.select = e
				console.log('fontItem', fontItem)
				this.dataItem.setfontFamily.fontList = []
				this.dataFontList.forEach(item => {
					if (item.select) {
						this.dataItem.setfontFamily.fontList.push(item)
					}
					if (item.code == this.dataItem.setfontFamily.name && !item.select) {
						this.dataItem.setfontFamily.name = ''
						this.dataItem.setfontFamily.css = ''
						this.dataItem.setfontFamily.fontFamily = ''
					}
				})

				if (this.dataItem.setfontFamily.fontList.length == 1) {
					let selectItem = this.dataItem.setfontFamily.fontList[0]
					this.dataItem.setfontFamily.fontFamily = selectItem.name
					this.dataItem.setfontFamily.name = selectItem.code
					this.dataItem.setfontFamily.css = selectItem.css
				}


			},
			getFontStyle(fontItem) {
				console.log('fontItem', fontItem)
				if (!document.getElementById(fontItem.name)) {
					var style = document.createElement('style');
					style.type = 'text/css';
					style.id = fontItem.name
					style.innerHTML = fontItem.css;
					document.getElementsByTagName('HEAD').item(0).appendChild(style);
				}
				return {
					fontFamily: fontItem.name
				}
			},
			selectFont() {
				this.dataItem.setfontFamily.fontList.forEach(item => {
					if (item.name == this.dataItem.setfontFamily.fontFamily) {
						this.dataItem.setfontFamily.name = item.code
						this.dataItem.setfontFamily.css = item.css
					}
				})
				console.log('this.dataItem.setfontFamily', this.dataItem.setfontFamily)
				// this.dataItem.setfontFamily.fontFamily
			},
			delFont(fontItem, index) {
				this.dataItem.setfontFamily.fontList.splice(index, 1)
				if (fontItem.code == this.dataItem.setfontFamily.name) {
					this.dataItem.setfontFamily.name = ''
					this.dataItem.setfontFamily.css = ''
					this.dataItem.setfontFamily.fontFamily = ''
					if (this.dataItem.setfontFamily.fontList.length > 0) {
						this.dataItem.setfontFamily.name = this.dataItem.setfontFamily.fontList[0].code
						this.dataItem.setfontFamily.css = this.dataItem.setfontFamily.fontList[0].css
						this.dataItem.setfontFamily.fontFamily = this.dataItem.setfontFamily.fontList[0].name
					}
				}
				console.log('this.dataItem.setfontFamily', this.dataItem.setfontFamily)
				console.log('fontItem', fontItem)
				this.fifter()
			},
			fifter() {
				let list = []
				this.dataFontList.forEach(item => {
					item.select = false
				})
				this.dataFontList.forEach(item => {
					this.dataItem.setfontFamily.fontList.forEach(fontItem => {
						if (item.code == fontItem.code) {
							item.select = true
						}
					})
				})
			},
			addFont() {
				let exits = false
				let selectItem;
				this.dataFontList.forEach(item => {
					if (this.addFontFamily == item.name) {
						this.dataItem.setfontFamily.fontList.forEach(fontItem => {
							if (this.addFontFamily == fontItem.name) {
								exits = true
							}
						})
						selectItem = item
					}
				})
				if (exits) {
					this.$message.error('字体已存在选择列表当中')
				} else {
					this.dataItem.setfontFamily.fontList.push(selectItem)
					if (this.dataItem.setfontFamily.fontList.length == 1) {
						this.dataItem.setfontFamily.fontFamily = selectItem.name
						this.dataItem.setfontFamily.name = selectItem.code
						this.dataItem.setfontFamily.css = selectItem.css
					}
					this.$message.success('添加成功')
					this.fifter()
				}
				this.addFontFamily = ''

			},
			ipt(e, field) {
				e[field] = e[field].replace(/\D/g, '')
			},
			changeIpt(e) {
				console.log('e', e)
			}
		}
	}
</script>

<style scoped lang="scss">
	::v-deep .el-input__inner:focus {
		border-color: #242754
	}
</style>